import React, { useState, useEffect } from 'react';
import { MapPin, Phone } from 'lucide-react';
import { contactInfo as defaultContact } from '../data/mock';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ContactSection = () => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await fetch(`${API_URL}/api/content`);
        if (response.ok) {
          setContent(await response.json());
        }
      } catch (error) {
        console.error('Error fetching content:', error);
      }
    };
    fetchContent();
  }, []);

  const contactInfo = content ? {
    title: "Nous trouver",
    subtitle: "Notre siège social",
    address: content.address,
    phone: content.phone,
    email: content.email
  } : defaultContact;

  return (
    <section id="contact" className="py-24 md:py-32 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <p className="text-stone-500 text-sm tracking-[0.25em] uppercase mb-3">
            Contact
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-stone-800 font-light">
            {contactInfo.title}
          </h2>
          <div className="w-16 h-px bg-stone-300 mx-auto mt-6" />
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Contact Info */}
          <div className="space-y-8">
            <div>
              <h3 className="font-serif text-2xl text-stone-800 mb-6">
                {contactInfo.subtitle}
              </h3>
              
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-full bg-stone-100 flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-5 h-5 text-stone-600" />
                  </div>
                  <div>
                    <p className="font-medium text-stone-800">Adresse</p>
                    <p className="text-stone-600">{contactInfo.address}</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-full bg-stone-100 flex items-center justify-center flex-shrink-0">
                    <Phone className="w-5 h-5 text-stone-600" />
                  </div>
                  <div>
                    <p className="font-medium text-stone-800">Téléphone</p>
                    <p className="text-stone-600">{contactInfo.phone}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Company name styled with logo */}
            <div className="p-6 bg-white rounded-lg shadow-sm border border-stone-100 flex items-center gap-6">
              <div className="flex-1">
                <p className="font-serif text-xl text-stone-800">
                  DÉCORATION DE SOUSA FRÈRES
                </p>
                <p className="text-stone-500 text-sm mt-2">
                  Spécialistes du second œuvre depuis 1965
                </p>
              </div>
              <img 
                src="https://customer-assets.emergentagent.com/job_renovation-pro-8/artifacts/8suehnvt_DECO.png" 
                alt="Logo DE SOUSA" 
                className="w-24 h-24 object-contain"
              />
            </div>
          </div>

          {/* Map - Google Maps */}
          <div className="h-[400px] lg:h-[500px] rounded-xl overflow-hidden shadow-lg border border-stone-200">
            <iframe
              src="https://www.google.com/maps?q=6+rue+du+Pr%C3%A9+de+l%27H%C3%B4pital,+94190+Villeneuve-Saint-Georges,+France&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localisation du siège - 6 rue du Pré de l'Hôpital, Villeneuve-Saint-Georges"
              className="w-full h-full"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
